const constants = {
  // L1 Native Config
  NATIVE_CHAIN_NAME: `Lamina1 ${process.env.NATIVE_CHAIN_NAME}`,
  NATIVE_CHAIN_TICKER: 'L1',
  NATIVE_CHAIN_ID: Number(process.env.NATIVE_CHAIN_ID) || 43112,
  NATIVE_CHAIN_RPC: process.env.NATIVE_CHAIN_RPC || 'http://localhost:9650/ext/bc/C/rpc',
  EXPLORER_URL: process.env.NATIVE_CHAIN_EXPLORER_URL || 'https://explorer.lamina1.com',

  // Identity Subnet Config
  IDENTITY_SUBNET_NAME: `Lamina1 ${process.env.IDENTITY_SUBNET_NAME}`,
  IDENTITY_SUBNET_TICKER: 'L1ID',
  IDENTITY_SUBNET_ID: Number(process.env.IDENTITY_SUBNET_ID) || 12345,
  IDENTITY_SUBNET_RPC:
    process.env.IDENTITY_SUBNET_RPC || 'http://localhost:9650/ext/bc/identitytest/rpc',

  // Identity Subnet Contracts
  CONTRACT_CONTROLLER_ADDRESS:
    process.env.CONTRACT_CONTROLLER_ADDRESS || '0xa4DfF80B4a1D748BF28BC4A271eD834689Ea3407',

  CONTRACT_RESOLVER_ADDRESS:
    process.env.CONTRACT_RESOLVER_ADDRESS || '0x8B3BC4270BE2abbB25BC04717830bd1Cc493a461',

  CONTRACT_COLLECTOR_ADDRESS:
    process.env.CONTRACT_COLLECTOR_ADDRESS || '0x52C84043CD9c865236f11d9Fc9F56aa003c1f922',

  CONTRACT_SPACES_REGISTRY_ADDRESS:
    process.env.CONTRACT_SPACES_REGISTRY_ADDRESS || '0xA4cD3b0Eb6E5Ab5d8CE4065BcCD70040ADAB1F00',

  // Web3 Auth Config
  WEB3AUTH_CLIENT_ID:
    process.env.WEB3AUTH_CLIENT_ID ||
    'BH0Cp1N7-v87NV1_4HmkQCuRuvDP5X5321etOkf46Rk1Y7_G4X_7LRH5TzG3S9K2GyH3jiIkVMGQLKg8RBY_nZM',
}

export default constants
